import { RouterProvider } from "react-router-dom";
import { useEffect, useState } from "react";

// project import
import router from "routes";
import ThemeCustomization from "themes";

import Locales from "components/Locales";
import RTLLayout from "components/RTLLayout";
import ScrollTop from "components/ScrollTop";
import Snackbar from "components/@extended/Snackbar";
import LogoLoader from "components/LogoLoader";

// material-ui
import { Paper, Typography, Box } from "@mui/material";
import { WifiOff } from "lucide-react";

// auth-provider
import { JWTProvider as AuthProvider } from "contexts/JWTContext";
// notification-provider
import { NotificationProvider } from "contexts/NotificationContext";

import { Provider } from "react-redux";
import store from "store/reducers";

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

export default function App() {
  const [appReady, setAppReady] = useState(false);
  const [showOfflineModal] = useState(false);

  // // Set up network detection
  // useEffect(() => {
  //   const handleOnline = () => {
  //     setIsOnline(true);
  //     setShowOfflineModal(false);
  //   };

  //   const handleOffline = () => {
  //     setIsOnline(false);
  //     // Show modal after a short delay to avoid flashing on brief disconnections
  //     setTimeout(() => {
  //       if (!navigator.onLine) {
  //         setShowOfflineModal(true);
  //       }
  //     }, 2000);
  //   };

  //   // Set up event listeners
  //   window.addEventListener("online", handleOnline);
  //   window.addEventListener("offline", handleOffline);

  //   // Check connection on mount
  //   checkConnection();

  //   // Clean up
  //   return () => {
  //     window.removeEventListener("online", handleOnline);
  //     window.removeEventListener("offline", handleOffline);
  //   };
  // }, []);

  // Function to actually check if the server is reachable
  // const checkConnection = () => {
  //   fetch("/api/health-check", {
  //     method: "HEAD",
  //     cache: "no-store",
  //     headers: { pragma: "no-cache" },
  //   })
  //     .then((response) => {
  //       if (response.ok) {
  //         setShowOfflineModal(false);
  //       } else {
  //         setShowOfflineModal(true);
  //       }
  //     })
  //     .catch(() => {
  //       setShowOfflineModal(true);
  //     });
  // };

  // Handle manual navigation to maintenance page
  // const goToMaintenancePage = () => {
  //   router.navigate("/maintenance/under-construction");
  //   setShowOfflineModal(false);
  // };

  // Handle retry connection
  // const handleRetryConnection = () => {
  //   checkConnection();
  // };

  // Continue offline
  // const handleContinueOffline = () => {
  //   setShowOfflineModal(false);
  // };

  useEffect(() => {
    // Simulate application initialization
    const timer = setTimeout(() => {
      setAppReady(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Provider store={store}>
      <ThemeCustomization>
        <RTLLayout>
          <Locales>
            <ScrollTop>
              {!appReady ? (
                <LogoLoader />
              ) : (
                <AuthProvider>
                  <NotificationProvider>
                    <>
                      <RouterProvider router={router} />
                      <Snackbar />

                      {/* Offline Paper Model */}
                      {showOfflineModal && (
                        <Box
                          sx={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            bgcolor: "rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 9999,
                          }}
                        >
                          <Paper
                            elevation={6}
                            sx={{
                              p: 3,
                              width: "100%",
                              maxWidth: 400,
                              borderRadius: 2,
                              textAlign: "center",
                            }}
                          >
                            <WifiOff
                              size={40}
                              color="#f44336"
                              style={{ marginBottom: 16 }}
                            />
                            <Typography variant="h5" gutterBottom>
                              Connection Lost
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              paragraph
                            >
                              Your network connection has been lost. Some
                              features may be unavailable.
                            </Typography>
                          </Paper>
                        </Box>
                      )}
                    </>
                  </NotificationProvider>
                </AuthProvider>
              )}
            </ScrollTop>
          </Locales>
        </RTLLayout>
      </ThemeCustomization>
    </Provider>
  );
}
